import { render, staticRenderFns } from "./FAQTab.vue?vue&type=template&id=13ffebb8&scoped=true"
import script from "./FAQTab.vue?vue&type=script&lang=js"
export * from "./FAQTab.vue?vue&type=script&lang=js"
import style0 from "./FAQTab.vue?vue&type=style&index=0&id=13ffebb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ffebb8",
  null
  
)

export default component.exports